if (!customElements.get('faq-slider')) {
  class FaqSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      new Splide(this, {
        perPage: 1,
        arrows: true,
        pagination: false,
        mediaQuery: 'min',
        breakpoints: {
          768: {
            destroy: true
          }
        }
      }).mount();
    }
  }
  customElements.define('faq-slider', FaqSlider);
}
